import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import { DeparturePicker } from '../components/departure-picker.js';

$(() => {
    detailsPackage.init();
});

const detailsPackage = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: 2,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && +this.$booking.attr('data-dynamicpackage') === 2)) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.referenceId = this.$booking.attr('data-referenceid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        //this.getCalculation();
        
        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        // check availability on form change (not only on btn click)
        $('[name="dates"], [name=guests]').on('change', () => {
            const data = functions.getFormData(this.$form);
            if ( data.dates && data.guests ) {
                this.$form.trigger('submit');
            }
        });

        this.prepareAvailabilityForm();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $('.btn-book-one-unit').on('click', e => {
            const $target = $(e.currentTarget);

            if (! this.params.dateFrom || ! this.params.dateTo || ! this.params.guests) {
                window.setAlertBooking($target);
                /*let $alertBooking = $target.closest('.unit').find('.alert-booking');
                $alertBooking.addClass('active');
                setTimeout(() => {
                    $alertBooking.removeClass('active');
                }, 4000);*/
            }
        });

        $(window).on('hashchange', e => {
            this.getParams();
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.showTransportTicket();

            this.getCalculation(this.params);
        });
    },
    prepareAvailabilityForm() {
        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: 2,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
        }).always(response => {
            response = response ? JSON.parse(response) : null;

            if (response.status) {
                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                const serviceCodes = response.data.serviceCodes;
                //const $nights = $("[name='nights']");

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = prepared.prices;

                const $service = $("[name='serviceCode']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                if (serviceCodes.length) {
                    $serviceWrapper.removeClass('d-none')
                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key === serviceCode) {
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });
                } else {
                    $serviceWrapper.addClass('d-none');
                }

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => {
                    return a - b
                });

                if (nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text: night})

                        if (!this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    /*$nights.select2({
                        data: _nights,
                        minimumResultsForSearch: -1
                    });*/

                    //setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }

                const $detailsDatepicker = $("#details-datepicker");
                $detailsDatepicker.attr('data-departures', JSON.stringify(this.enable));
                $detailsDatepicker.attr('data-flights', JSON.stringify(this.flights));
                $detailsDatepicker.attr('data-prices', JSON.stringify(this.prices));

                $detailsDatepicker.find('[data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });

                this.setDefaultDeparture();
                functions.setFormData(this.form, this.params);

                // showFlightTickets must MANDATORY be after setFormData
                this.params.dateFrom && this.showTransportTicket();

                this.getCalculation();

                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);

                    this.params.dateFrom = data.dateFrom;
                    this.params.dateTo = data.dateTo;
                    this.params.guests = data.guests;
                    this.params.time = data.time;
                    this.params.duration = data.duration;

                    functions.setUrlData(
                        {
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'guests': this.params.guests,
                            'time': this.params.time,
                            'duration': this.params.duration,
                            'transportUnitId': this.params.transportUnitId,
                        },
                        true,
                        true);
                });

                $(document).on('click', '.ticket', e => {
                    this.setTransportTicket($(e.currentTarget), true);
                });

            }
        });
    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            // let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            //let unique = rate.aDateFrom + ',' + rate.aDateTo + ',' + rate.dateFrom + ',' + rate.dateTo;
            let unique = rate.dateFrom + ',' + rate.dateTo;
            
            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;

            if ( flight.timeDepartureFrom ) {
                flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
            }

            let flightUnique = flightUnitId + (flight.time ? '_' + flight.time : '');

            if ( ! departures[unique]) {
                let flights = {};
                flights[flightUnique] = flight;

                let rates = {};
                rates[rate.id] = rate;

                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flights'       : flights,
                    'rates'         : rates,
                };
            } else {
                let departure = departures[unique];
                departure.flights[flightUnique] = flight;
                departure.rates[rate.id] = rate;
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                aDateFrom: rate['aDateFrom'],
                aDateTo: rate['aDateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
            });

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let departureDay = detailsPackage.getWeekDay(arrival);
            let returnArrivalDay = detailsPackage.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                let flightSmallImg;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                        flightSmallImg = ft.images.small ? ft.images.small : '';
                    }
                });

                let arrivalDay = detailsPackage.getWeekDay(arrivalDate);
                let returnDepartureDay = detailsPackage.getWeekDay(returnDate);
                
                flights.push({
                    duration              : rate.duration,
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightSmallImg        : flightSmallImg,
                    flightUnitId          : flight.unitId,
                    departureDay          : departureDay,
                    returnDepartureDay    : returnDepartureDay,
                    arrivalDay            : arrivalDay,
                    returnArrivalDay      : returnArrivalDay,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    showTransportTicket(){
        const dataTransport = JSON.parse($('[data-flights]').attr('data-flights'));

        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let duration = this.params.duration;
        let time = this.params.time != ' ' && (this.params.time && ! this.params.time.startsWith('null')) ? this.params.time : null;

        if (duration) {
            if (! $('.duration-item[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"][data-duration="' + duration + '"]').length) {
                duration = this.params.duration = null;
            }
        }

        if (! duration && $('.duration-item.active').length) {
            duration && $('.duration-item.active').attr('data-duration');
        }

        let tickets = dataTransport.filter(ticket => {
            return ticket.dateFrom == dateFrom 
                && ticket.dateTo == dateTo 
                && (duration ? ticket.duration == duration : true)
                && (time ? ticket.time == time : true);
        });

        tickets.sort((a, b) => {
            return a.duration - b.duration;
        });

        this.renderTransportTickets(tickets);
    },
    renderTransportTickets(tickets) {
        const $tickets = $('.tickets').empty();

        let hasActiveTicket = tickets.find((ticket) => {
            return ticket.flightUnitId == this.params.transportUnitId;
        });

        tickets.forEach((ticket, index) => {
            const time = ticket.timeDepartureFrom && ticket.timeReturnFrom ? ticket.timeDepartureFrom + ',' + ticket.timeReturnFrom : null;
            this.params.time = ! this.params.time && index == 0 ? time : this.params.time;

            if ( ! hasActiveTicket && index == 0) {
                this.params.transportUnitId = ticket.flightUnitId;
            }

            $tickets.append(`
                <div class="ticket"
                    data-aDateFrom="${ ticket.aDateFrom }"
                    data-aDateTo="${ ticket.aDateTo }"
                    data-transportUnitId="${ ticket.flightUnitId }">

                    <div class="row g-0">
                        <div class="col-md">
                            <div class="ticket-departure">
                                <div class="row flex-nowrap">
                                    <div class="col-auto">
                                        <div>${ ticket.placeFromName }</div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.dateFrom) }</div>
                                        <div class="small">${ ticket.departureDay }</div>
                                    </div>
                                    <div class="col d-flex justify-content-between align-items-center">
                                        <hr class="d-none d-lg-block" />
                                        <i class="fa-solid fa-bus-side"></i>
                                        <hr class="d-none d-lg-block" />
                                    </div>
                                    <div class="col-auto">
                                        <div>${ ticket.placeToName }</div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.arrivalDate) }</div>
                                        <div class="small">${ ticket.arrivalDay }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="ticket-return">
                                <div class="row flex-nowrap">
                                    <div class="col-auto">
                                        <div>${ ticket.placeToName }</div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.returnDate) }</div>
                                        <div class="small">${ ticket.returnDepartureDay }</div>
                                    </div>
                                    <div class="col d-flex justify-content-between align-items-center">
                                        <hr class="d-none d-lg-block" />
                                        <i class="fa-solid fa-bus-side"></i>
                                        <hr class="d-none d-lg-block" />
                                    </div>
                                    <div class="col-auto">
                                        <div>${ ticket.placeFromName }</div>
                                        <div class="fw-bold">${ functions.formatDate(ticket.dateTo) }</div>
                                        <div class="small">${ ticket.returnArrivalDay }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ticket-tail">
                        <div class="ticket-tail-check">
                            <i class="fa-light fa-check"></i>
                        </div>
                    </div>
                    
                </div>    
            `);

            //this.params.aDateFrom = $('.ticket.active').attr('data-adatefrom');
            //this.params.aDateTo = $('.ticket.active').attr('data-adateto');

            const $ticket = $('.ticket[data-transportUnitId="' +  this.params.transportUnitId + '"]');
            $ticket.length && this.setTransportTicket($ticket);
        });
    },
    setTransportTicket($ticket, triggerChange = false) {
        $('.ticket').removeClass('active');
        $ticket.addClass('active');

        this.getParams();
        let time = $ticket.attr('data-time');
        let aDateFrom = $ticket.attr('data-adatefrom');
        let aDateTo = $ticket.attr('data-adateto');
        let unitId = $ticket.attr('data-transportunitid');

        //$('[name="time"]').val(time);
        //$('[name="aDateFrom"]').val(aDateFrom);
        //$('[name="aDateTo"]').val(aDateTo);

        this.params.time = time;
        this.params.aDateFrom = aDateFrom;
        this.params.aDateTo = aDateTo;
        this.params.transportUnitId = unitId;

        triggerChange && this.$form.change();
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        ! this.params.time && departure && (this.params.time = departure.time);
        
        departure = departure || this.departures[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time]
        this.params.aDateFrom = departure && departure.aDateFrom ? departure.aDateFrom : null;
        this.params.aDateTo = departure && departure.aDateTo ? departure.aDateTo : null;
        this.params.transportUnitId = departure && departure.flightUnitId ? departure.flightUnitId : null;
        
        //this.params.dateFrom = ! this.params.dateFrom && departures.length ? departures[0].dateFrom : this.params.dateFrom;
        //this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && departures.length ? departures[0].dateTo : this.params.dateTo;
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        const calculation = details.getCalculation(cParams);

        if(calculation) {
            details.unitsSpinner();
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        } else {

            //$('.block-no-dates').removeClass('d-none');
            //$('.block-discount').removeClass('d-none');
            //$('.block-loading').addClass('d-none');
        }

        //$('.block-totals-per-service').addClass('d-none');
        //$('.block-booking').addClass('d-none');
        //$('.block-error-msg').addClass('d-none');
    },
    calculationDone(response, params) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);
                
                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    let hasDiscount = priceOld && priceOld != unitCalc.total ? priceOld : null;

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);

                    if (hasDiscount) {
                        priceOld && $unit.find('.price-old').html(totalOld);
                        discountTitle && $unit.find('.badge-discount').html(discountTitle);
                        discountTitle && $unit.find('.badge-discount').removeClass('d-none');
                    } else {
                        $unit.find('.price-old').html('');
                        $unit.find('.badge-discount').addClass('d-none');
                    }

                    $unit.prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $unit.find('.price').toggleClass('text-danger', priceOld > unitCalc.total);

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);
                    
                    $addToCart.attr('data-datefrom', detailsPackage.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsPackage.params.dateTo);
                    $addToCart.attr('data-guests', detailsPackage.params.guests);

                    $addToCart.attr('data-adatefrom', detailsPackage.params.aDateFrom);
                    $addToCart.attr('data-adateto', detailsPackage.params.aDateTo);
                    $addToCart.attr('data-transportunitid', detailsPackage.params.transportUnitId);
                } else {
                    $unit.prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-message').text(error);

                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);

            });

            if(this.$cart.length) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 2,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=2';

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {
                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget); 
                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsPackage.params.dateFrom,
                            'dateTo': detailsPackage.params.dateTo,
                            'guests': detailsPackage.params.guests,
                            'dynamicPackage': 2,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=2'; // &dynamicPackage=0
                });
            }
        }
    }
};